"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BugDispatcher_1 = require("../BugDispatcher");
var ScoreNotifier_1 = require("../ScoreNotifier");
var Bootstrap = /** @class */ (function () {
    function Bootstrap() {
        this.$BugsControllers = [];
        this.$BugsDispachersOptions = [];
        this.observers = [];
        this.$maxScore = 12;
        this.$score = 0;
        this.$highScore = 0;
        this.$timer = 0;
        this.$onSubmitFn = function (data) { };
    }
    Bootstrap.getInstance = function () {
        if (!Bootstrap.instance) {
            Bootstrap.instance = new Bootstrap();
        }
        return Bootstrap.instance;
    };
    Bootstrap.prototype.run = function () {
        var _this = this;
        this.$BugsControllers = this.$BugsDispachersOptions.map(function (bugDispatcherOptions) { return new BugDispatcher_1.default(_this, bugDispatcherOptions); });
        this.$scoreNotifier = new ScoreNotifier_1.default(this);
        // aqui renderizo el score;
    };
    Bootstrap.prototype.addScore = function (points) {
        if (this.$score === 0)
            this.startTimer();
        this.$score += 1;
        var formatted = this.getFormattedTime();
        if (this.$score === this.$maxScore) {
            window.onKillAllBugs(this.$score, formatted);
            this.endGame();
            clearTimeout(this.$intervalId);
        }
        else {
            window.onKillOneBug(this.$score, this.getFormattedTime());
        }
        this.notify(this.$score);
        this.$scoreNotifier.showMessage(this.$score, this.getFormattedTime());
    };
    Bootstrap.prototype.endGame = function () {
        this.$BugsControllers.forEach(function (controller) {
            controller.removeAll();
        });
        // this.$scoreNotifier.removeAllCards()
    };
    Bootstrap.prototype.setOnSubmitFn = function (submitFn) {
        if (submitFn === void 0) { submitFn = function (data) { }; }
        this.$onSubmitFn = submitFn;
    };
    Bootstrap.prototype.onSubmit = function (_args) {
        if (_args === void 0) { _args = {}; }
        // mostramos el modal
        window.onShowModalSubmitScore(this.$score, this.getFormattedTime());
        this.$onSubmitFn({
            score: this.getFormattedTime(),
            score_ms: this.$timer,
        });
    };
    Bootstrap.prototype.addController = function (options) {
        if (options === void 0) { options = {}; }
        this.$BugsDispachersOptions.push(options);
    };
    Bootstrap.prototype.getFormattedTime = function () {
        var seconds = Math.floor(this.$timer / 1000);
        var minutes = Math.floor(seconds / 60);
        var displaySeconds = seconds % 60;
        return "".concat(minutes.toString().padStart(2, '0'), ":").concat(displaySeconds.toString().padStart(2, '0'));
    };
    Bootstrap.prototype.startTimer = function () {
        var _this = this;
        var startTime = Date.now();
        this.$intervalId = setInterval(function () {
            _this.$timer = Date.now() - startTime;
        }, 1000);
    };
    Bootstrap.prototype.subscribe = function (observer) {
        this.observers.push(observer);
    };
    Bootstrap.prototype.unsubscribe = function (observer) {
        this.observers = this.observers.filter(function (o) { return o !== observer; });
    };
    Bootstrap.prototype.notify = function (data) {
        this.observers.forEach(function (o) { return o.onUpdateScore(data); });
    };
    return Bootstrap;
}());
exports.default = Bootstrap;
